import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from '@/components/DropdownMenu';
import { FilterIcon, SearchIcon, SortIcon } from '@/components/Icons';
import { FEATURE_FLAG_CONFIG } from '@/config';
import { SortOrderType } from '@/service/type';
import { cn } from '@/utils';
import useFlags from '@jenmusic/feature-flag';
import { useThrottle, useThrottleFn } from 'ahooks';
import React, { useState } from 'react';

const orderValMapName = {
  LF: 'LATEST FIRST',
  EF: 'EARLIEST FIRST',
  LS: 'LONGEST - SHORTEST',
  SL: 'SHORTEST - LONGEST',
  AZ: 'A-Z',
  ZA: 'Z-A',
  SF_ARTIST: 'StyleFilter: Imogen Heap',
};

type OrderType = SortOrderType;

interface SearchProps {
  order: OrderType;
  setOrder: (order: OrderType) => void;
  onClickSearch: () => void;
  className?: string;
}

const Search: React.FC<SearchProps> = ({ order, setOrder, onClickSearch, className }) => {
  const { showStyleFilters } = useFlags<typeof FEATURE_FLAG_CONFIG>();
  const orders: SortOrderType[] = ['LF', 'EF', 'LS', 'SL', 'AZ', 'ZA'];
  if (showStyleFilters) {
    orders.push('SF_ARTIST');
  }

  return (
    <div className={cn('flex justify-between items-center text-jen-grey-3 text-[10px] gap-[16px]', className)}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className=" text-jen-interactive-tertiary flex items-center cursor-pointer  p-[4px] pr-[12px] rounded-jen-spacing-4 border-jen-border border hover:bg-jen-lightest-grey-100">
            <FilterIcon fillColor="currentColor" />
            <div className="font-pressura-mono text-[12px]">
              SORT BY: <span>{orderValMapName[order]}</span>
            </div>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-[189px] bg-white  text-black text-[10px] ">
          <DropdownMenuRadioGroup value={order} onValueChange={(value) => setOrder(value as OrderType)}>
            {orders.map((order) => (
              <DropdownMenuRadioItem key={order} value={order}>
                {orderValMapName[order]}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
      <div className="flex p-[4px] border rounded-jen-spacing-4 border-jen-border hover:bg-jen-lightest-grey-100" onClick={onClickSearch}>
        <SearchIcon fillColor="currentColor" className=" cursor-pointer  " />
      </div>
    </div>
  );
};

export default Search;
